goog.provide('el8.ptdata.model.note.bill');

goog.require('el8.data.model.copayPayment');
goog.require('el8.data.serviceLocations');
goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.util.base');
goog.require('el8.data.icd9Codes');

// ---------------------
// * VISIT NOTE BILL *
// ---------------------
(function() {

    /** BillDx - Which used to be a ICD9 code as a string Dx and is an ICD10 code with and
        optional list of associated 9s (to help verify/assist with coding) */
    var _classDx = function(spec) {
        this.populate(spec || {});
    };

    _classDx.inheritsFrom(el8_Entity);
    _classDx.addStringProperty('dx', true);
    _classDx.addIntProperty('sequence', true);
    _classDx.addModelSetProperty('icd9Codes', el8.data.icd9Codes._model, true, []);
    _classDx.addProperty('icd10Code', true);

    _classDx.prototype.asMap = function(underscore, prefixBools) {
        var serverMap = el8_Entity.prototype.asMap.call(this);

        var icd9Key = underscore ? 'icd9_code_ids' : 'icd9CodeIds';
        serverMap[icd9Key] = _.pluck(serverMap['icd9Codes'], 'id');
        delete serverMap['icd9Codes'];

        var icd10Key = underscore ? 'icd10_code_id' : 'icd10CodeId';
        serverMap[icd10Key] = serverMap.icd10Code ? serverMap.icd10Code.id : null;
        delete serverMap['icd10Code'];

        return serverMap;
    };

    el8.ptdata.model.note.billDx = function(spec) {
        return new _classDx(spec);
    };

    // BillCpt - contains a CPT, list of DXs, and other info about the CPT code
    //
    // These are not the same as el8.data.cptCodes. They are really billing
    // line items. Sadly these have modifiers but cptCodes do not...
    var _classCpt = function(spec) {
        this.populate(spec || {});
    };
    _classCpt.inheritsFrom(el8_Entity);
    _classCpt.prototype.populate = function(spec) {
        spec = spec || {};
        spec.model_class = 'BillCpt';
        if (spec.dxs) {
            spec.dxs = spec.dxs.map(el8.ptdata.model.note.billDx);
        }
        this.parent.populate.call(this, spec);
    };
    _classCpt.addStringProperty('cpt', true);
    _classCpt.addStringProperty('modifier1', true);
    _classCpt.addStringProperty('modifier2', true);
    _classCpt.addStringProperty('modifier3', true);
    _classCpt.addStringProperty('modifier4', true);
    _classCpt.addDecimalProperty('units', true);
    _classCpt.addDecimalProperty('charge', true);
    _classCpt.addModelSetProperty('dxs', el8.ptdata.model.note.billDx, true, []);
    _classCpt.addIntProperty('sequence', true);

    // convenience to deal with all modifiers together
    _classCpt.prototype.getModifiers = function() {
        return _.compact([this.getModifier1(), this.getModifier2(), this.getModifier3(), this.getModifier4()]);
    };

    _classCpt.prototype.asMap = function(var_args) {
        var serverMap = this.parent.asMap.apply(this, arguments);
        // By default, this will use the DX asSoyMap. That's not what we want,
        // but changing all addModelSetProperties is complicated.
        serverMap['dxs'] = this.getDxs().map(function(d) {
            return d.asMap.call(d, arguments);
        });
        return serverMap;
    };

    el8.ptdata.model.note.billCpt = function(spec) {
        return new _classCpt(spec);
    };

    /** The Bill itself - contains a list of BillCpts */
    var _class = function(spec) {
        this.populate(spec || {});
    };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        spec.model_class = 'Bill';
        if (spec.cpts ) {
            spec.cpts = spec.cpts.map(el8.ptdata.model.note.billCpt);
        }
        this.parent.populate.call(this, spec);
    };
    _class.addStringProperty('notes', true);

    _class.addStringProperty('referringProvider', true);
    _class.addStringProperty('referringProviderState', true);

    _class.addIntProperty('serviceLocationId', true);
    
    _class.addStringProperty('billingError');
    _class.addStringProperty('billingRawError'); // only populated if logged in as el8staff
    _class.addModelSetProperty('cpts', el8.ptdata.model.note.billCpt, true, []);

    _class.addDateTime('billingDate');
    _class.addStringProperty('refNumber');

    _class.addIntProperty('billingStatus', true);
    _class.addBoolean('earlyBill', true);
    _class.addBoolean('deferredBill', true);
    _class.addBoolean('showDualCoding', true);

    _class.addModelProperty('copayCollected', el8.data.model.copayPayment, true);
    
    // These properties only exist for bills in billing report
    _class.addDateTime('noteDate');
    _class.addStringProperty('patientName');
    _class.addDate('patientDob');
    _class.addProperty('patientInsurance'); // dict containing carrier, group_id, member_id
    _class.addProperty('patientSecondaryInsurance'); // dict containing carrier, group_id, member_id

    _class.prototype.isEmpty = function() {
        return !this.getNotes() && !this.getCpts().length && 
                !this.getBillingDate() && !this.getRefNumber();
    };

    _class.prototype.addOrUpdateCpt = function(obj) {
        var existing = this.getCptById(obj.id);
        if (!existing) {
            var newCpt = el8.ptdata.model.note.billCpt(obj);
            var newCpts = [];
            for (var i=0; i<this.getCpts().length; i++) {
                newCpts.push(this.getCpts()[i]);
            }
            newCpts.push(newCpt);
            newCpts.sort(function(a, b) { return a.getSequence() > b.getSequence(); });
            this.setCpts(newCpts);
            return newCpt;
        } else {
            return existing;
        }
    };

    _class.prototype.getCptById = function(id) {
        var cpts = this.getCpts();
        for (var i=0; i<cpts.length; i++) {
            if (cpts[i].getId() === id) {
                return cpts[i];
            }
        }
        return null;
    };

    _class.prototype.getDxById = function(cpt, id) {
        var dxs = cpt.getDxs();
        for (var i=0; i<dxs.length; i++) {
            if (dxs[i].getId() === id) {
                return dxs[i];
            }
        }
        return null;
    };

    _class.prototype.addOrUpdateDx = function(cptId, obj) {
        var cpt = this.getCptById(cptId);
        if (cpt) {
            var existing = this.getDxById(cpt, obj.id);
            if (existing) { return existing; }
            var newDx = el8.ptdata.model.note.billDx(obj);
            var newDxs = [];
            for (var i=0; i<cpt.getDxs().length; i++) {
                newDxs.push(cpt.getDxs()[i]);
            }
            newDxs.push(newDx);
            newDxs.sort(function(a, b) { return a.getSequence() > b.getSequence(); });
            cpt.setDxs(newDxs);
            return newDx;
        }
        return null;
    };

    // Checks whether the bill has any unstructured DXs, which
    // are deprecated for new bills
    _class.prototype.hasUnstructuredDxs = function() {
        var cpts = this.getCpts();
        var dxs = _.compact(_.flatten(cpts.map(function(c) { return c.getDxs(); })));
        var unstructuredDxs = dxs.filter(function(d) {
            return Boolean(d.getDx());
        });
        return Boolean(unstructuredDxs.length);
    };
    _class.prototype.hasIcd10s = function() {
        var cpts = this.getCpts();
        var dxs = _.compact(_.flatten(cpts.map(function(c) { return c.getDxs(); })));
        var icd10s = dxs.filter(function(d) {
            return Boolean(d.getIcd10Code());
        });
        return Boolean(icd10s.length);
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['patientInsurance'] = el8.util.keysFromUnderscoreToCamel(this.getPatientInsurance());
        mapped['patientSecondaryInsurance'] = el8.util.keysFromUnderscoreToCamel(this.getPatientSecondaryInsurance());
        if (this.getServiceLocationId()) {
            var serviceLocation = el8.data.serviceLocations.getById(this.getServiceLocationId());
            if (serviceLocation) {
                mapped['serviceLocation'] = serviceLocation.getName();
                mapped['serviceLocationPos'] = serviceLocation.getPlaceOfService();
                mapped['serviceLocationName'] = serviceLocation.getPlaceOfServiceName();
            }
            else {
                mapped['serviceLocation'] = '';
                mapped['serviceLocationPos'] = '';
                mapped['serviceLocationName'] = '';
            }
        }
        return mapped;
    };

    _class.prototype.asMap = function(var_args) {
        var serverMap = this.parent.asMap.apply(this, arguments);
        // By default, this will use the CPT asSoyMap. That's not what we want,
        // but changing all addModelSetProperties is complicated.
        serverMap['cpts'] = this.getCpts().map(function(c) {
            return c.asMap.call(c, arguments);
        });
        // Flatten out copay_collected and send up just copay ID (no change)
        // or copay amount (new amount)
        if (serverMap['copay_collected']) {
            if (serverMap['copay_collected']['id']) {
                serverMap['copay_id'] = serverMap['copay_collected']['id'];
            } else if (serverMap['copay_collected']['amount']) {
                serverMap['copay_amount'] = serverMap['copay_collected']['amount'];
            }
            delete serverMap['copay_collected'];
        }
        return serverMap;
    };

    // Looks for a copay recorded on an appointment from the same
    // day as noteId and attaches that copay to this bill (locally,
    // without saving)
    _class.prototype.fetchCopayFromAppointments = function(noteId, opts) {
        opts = opts || {};
        var async = (opts.async === true); // default to synchronous fetch
		
        var that = this;
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('relevantCopay', [noteId]),
            async: async,
            success: function(data) {
                if (data) {
                    that.setCopayCollected(el8.data.model.copayPayment(data));
                }
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };
    
    // optimize the selection of service location
    // will attempt to use the last service location used by this user
    _class.prototype.fetchServiceLocationFromLastBill = function(noteId, opts) {
        opts = opts || {};
        var async = (opts.async === true); // default to synchronous fetch
		
        var that = this;
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('serviceLocationLastBill', [noteId]),
            async: async,
            success: function(data) {
                if (data) {
                    that.setServiceLocationId(data['service_location_id']);
                }
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };
    

    // Looks for a copay recorded on an appointment from the same day as noteId and attaches
    // that copay to this bill (locally, without saving) and also get the billing note and
    // the referring provider info.
    // 
    //  Also used to repopulate the RP info only for existing bills with the repopulate option.
    if (el8Globals.FEATURES.FrontOfficeNewKareo) {
        _class.prototype.fetchInfoForBill = function(noteId, opts) {
            opts = opts || {};
            var async = (opts.async === true); // default to synchronous fetch
            var that = this;
            var repopulate = opts.repopulate || false;

            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('fetchInfoForBill', [noteId, repopulate]),
                async: async,
                success: function(data) {
                    if (data) {
                        if (!repopulate && data['payment']) {
                            that.setCopayCollected(el8.data.model.copayPayment(data['payment']));
                        }
                        if (!repopulate && data['billing_note']) {
                            that.setNotes(data['billing_note']);
                        }
                        if (data['referring_provider']) {
                            that.setReferringProvider(data['referring_provider']);
                        }
                        if (data['referring_provider_state']) {
                            that.setReferringProviderState(data['referring_provider_state']);
                        }
                    }

                    if (opts.successCb) { opts.successCb(); }
                }
            });
        };
    }

    el8.ptdata.model.note.bill = function(spec) {
        return new _class(spec);
    };

})();


